<div class="row">
	<div *ngIf="isRecoverExecuting(); else scanExecuting">
		<h2 id="hwscan-executing-rbs-title" role="heading" class="col title animated-dots" aria-live="polite">{{ 'hardwareScan.recoverBadSectors.executingTitle' | translate }}<span aria-hidden="true" *ngFor="let dot of threeDots">{{dot}}</span></h2>
	</div>
	<ng-template #scanExecuting>
		<h2 id="hwscan-executing-scan-title" role="heading" class="col title animated-dots" aria-live="polite">{{ 'hardwareScan.executingScanTitle' | translate:{'title':getDeviceTitle()} }}<span aria-hidden="true" *ngFor="let dot of threeDots">{{dot}}</span></h2>
	</ng-template>
</div>
<div class="row hwscan-header">
	<div class="col row1" aria-live="polite">
		<p id="hwscan-executing-subtitle" role="text" class="row">{{subTitle}}</p>
		<p id="hwscan-executing-warning-message" role="text" class="row">{{ 'hardwareScan.warningMessage' | translate }}</p>
	</div>
	<div class="row">
		<div class="row progress-div">
			<div class="row progress-percent-text">
				<p id="hwscan-executing-percent-value" role="text" class="progress-value-text">{{percent}}</p>
				<p class="progress-complete-text">% {{'hardwareScan.complete' | translate}}</p>
			</div>
		</div>
	</div>
</div>
<div class="col row hwscan-header">
	<mat-progress-bar mode="determinate" id="hwscan-progress-bar" [value]="percent"></mat-progress-bar>
	<div class="col col-12 row">
		<div class="col col-12 row">
			<div class="col col-12 cancel-check">
				<vtr-ui-hyperlink-button
					[matTooltip]="disableCancel ? ('hardwareScan.waitScanStarts' | translate) : ''"
					matTooltipClass="vtr-system-tooltip"
					hyperlinkStyle="xs-white"
					linkId="hwscan-cancel-btn"
					linkRole="button"
					[isDisabled]="disableCancel"
					[upperCaseLabel]="true"
					[label]="'hardwareScan.cancel' | translate"
					(hyperlinkClick)="onCancel()">
				</vtr-ui-hyperlink-button>
			</div>
		</div>
	</div>
</div>
